import { type LogLevel } from "./types";

export const log = (
	service: string,
	message: string,
	content?: Record<string, unknown>,
	level: LogLevel = "info"
) => {
	// This is an obvious exception, used for development
	// eslint-disable-next-line no-console
	console.log(`${message} `, {
		isMomentMetadata: true,
		level,
		service,
		content,
	});
};
